import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import {
  DESKTOP_MIN_WIDTH,
  REGISTER_DRIVER_LICENCE_BACK_NAME,
  REGISTER_DRIVER_LICENCE_FRONT_NAME,
  REGISTER_DRIVER_LICENCE_SWITCH,
  REGISTER_PASSPORT_NAME,
} from 'constants';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputDocumentUploadSwitch = ({ information, setInformation }) => {
  const { t } = useLang();

  const { isRegisterDriverLicenceSelected } = information;

  const handleChangeDocumentUpload = (e, docType) => {
    e.preventDefault();
    e.stopPropagation();

    let newInformation = {
      ...information,
      isRegisterDriverLicenceSelected: !isRegisterDriverLicenceSelected,
    };

    if (docType === 'DL') {
      newInformation = {
        ...newInformation,
        [REGISTER_PASSPORT_NAME]: null,
      };
    }

    if (docType === 'P') {
      newInformation = {
        ...newInformation,
        [REGISTER_DRIVER_LICENCE_FRONT_NAME]: null,
        [REGISTER_DRIVER_LICENCE_BACK_NAME]: null,
      };
    }

    setInformation(newInformation);
  };

  const renderFormCheckRadio1 = () => {
    const formCheckRadioClassName1 = REGISTER_DRIVER_LICENCE_SWITCH + '1';

    return (
      <FormCheckboxRadio
        name={REGISTER_DRIVER_LICENCE_SWITCH}
        className={`${formCheckRadioClassName1} ${
          isRegisterDriverLicenceSelected && 'active'
        }`}
        label={t('button_driver_licence')}
        isChecked={isRegisterDriverLicenceSelected}
        onClick={(e) => handleChangeDocumentUpload(e, 'DL')}
        styles={{
          marginRight: '8px',
        }}
      />
    );
  };

  const renderFormCheckRadio2 = () => {
    const formCheckRadioClassName2 = REGISTER_DRIVER_LICENCE_SWITCH + '2';

    return (
      <FormCheckboxRadio
        name={REGISTER_DRIVER_LICENCE_SWITCH}
        className={`${formCheckRadioClassName2} ${
          !isRegisterDriverLicenceSelected && 'active'
        }`}
        label={t('button_passport')}
        isChecked={!isRegisterDriverLicenceSelected}
        onClick={(e) => handleChangeDocumentUpload(e, 'P')}
        styles={{
          marginRight: '0px',
        }}
      />
    );
  };

  return (
    <FormGroupStyled>
      <FormLabel onClick={(e) => e.preventDefault()}>
        {t('registration_title_upload')}
      </FormLabel>
      {renderFormCheckRadio1()}
      {renderFormCheckRadio2()}
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 8px;
  position: relative;
  ${Fade};

  img {
    width: 100%;
    height: 230px;
    object-fit: contain;
    border-radius: 12px;
  }
`;
const FormLabel = styled(Form.Label)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;

  display: block;
  color: var(--ds-c-grey-dark);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export default FormInputDocumentUploadSwitch;
